import { BuildFontString } from "../utils/BuildFontString";
import { Div2Floor } from "../utils/Div2Floor";
import {
  enumElementBorderStyle,
  enumElementDrawStates,
  kDropDownButtonArrow,
  kDropDownRightMargin,
  kfontIconNameMini,
  kTriangleWidth
} from "../constants";
import { QStdButton } from "./QStdButton";
import { SetCtxFont } from "../utils/SetCtxFont";
import { Globals } from "./Globals.js";

export class QDropDownButton extends QStdButton {
  constructor() {
    super();
    this.fFontSize = 12;
    this.fFontName = "Arial";
    this.fBorderRadius = 2;
    this.fBorderThickness = 0;
    this.fBorderStyle = enumElementBorderStyle.roundBorder;
  }

  DrawAdornment(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    ctx.fillStyle = this.fEnabled
      ? Globals._themeMode.text.header
      : Globals._themeMode.text.disabled;

    var h = this.GetHeight();
    var w = this.GetWidth();

    var yPos = this.fVertOffset + Div2Floor(h); //Math.floor(h/2)

    var xPos = this.fHorzOffset + w - kTriangleWidth - kDropDownRightMargin;

    SetCtxFont(ctx, kfontIconNameMini);

    ctx.fillText(kDropDownButtonArrow, xPos, yPos);
  }

  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    ctx.save();
    // Fill pad
    ctx.lineWidth = 1;
    this.SetStdDrawStateButtonColors(ctx);
    ctx.fill(this.fClippedRegion);

    if (this.fCurDrawState !== enumElementDrawStates.Disabled) ctx.stroke(this.fClippedRegion);

    ctx.globalAlpha = 1.0;

    // Now Draw the text in the button
    this.SetStdDrawStateTextColors(ctx);

    var fontInfo = BuildFontString(this.fFontName, this.fFontSize, this.fBold, false);
    SetCtxFont(ctx, fontInfo);

    var txt = this.GetTruncLabel(); // fTruncLabel;
    var alignment = this.GetHAlignment();

    var txtHOffset = this.GetMarginH();
    if (alignment == "center") txtHOffset = Div2Floor(this.fWidth);
    else if (alignment == "right") txtHOffset = this.fWidth - this.GetMarginH();

    var txtVOffset = Div2Floor(this.fHeight) + 1;
    ctx.textAlign = alignment;
    ctx.textBaseline = "middle";

    ctx.fillText(txt, this.fHorzOffset + txtHOffset, this.fVertOffset + txtVOffset);

    // Draw arrow
    this.DrawAdornment(drawBuffer);
    ctx.restore();
  }

  GetHAlignment() {
    return "left";
  }

  GetMaxLabelWidth() {
    return this.GetWidth() - this.GetMarginH() * 2 - kTriangleWidth - kDropDownRightMargin;
  }

  GetCursor() {
    return "pointer";
  }

  GetParentPanel() {
    return this.fParentPanel;
  }
}
